import { deepPurple } from "@mui/material/colors";
import { FC, forwardRef } from "react";

import { PIC } from "@ryde/assets";
import { noop } from "@ryde/shared";
import { rydeColorsDashboardPage } from "@ryde/theme";

import { IsReadBase, IsReadStyled } from "./is-read.styled";

interface IIsReadProps {
  checked?: boolean;
  name?: string;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  dataE2EId?: string;
}

export const IsRead: FC<IIsReadProps> = forwardRef<HTMLElement, IIsReadProps>(
  ({ checked, name, onChange, disabled, dataE2EId }, ref) => {
    return (
      <IsReadStyled
        data-e2e-id={dataE2EId}
        ref={ref}
        onClick={e => {
          e.preventDefault();
          onChange?.(!checked);
        }}
      >
        {checked ? (
          <PIC.IsRead
            className="IsRead-Icon IsRead-Icon_checked_true"
            color={deepPurple.A400}
          />
        ) : (
          <PIC.IsNotRead
            className="IsRead-Icon IsRead-Icon_checked_false"
            color={rydeColorsDashboardPage.dashboardHeaderBorderColor}
          />
        )}
        <IsReadBase
          checked={checked}
          onChange={noop}
          name={name}
          disabled={disabled}
        />
      </IsReadStyled>
    );
  },
);
